angular.module('SpidApp')

.constant('SyncConfig', {
  config: {
    chunkLength: 100
  },
  Node: {
    host : 'http://localhost',
    port : 10000,
    getURL : function () {
      return this.host + ':' + this.port
    },
    getURLFor : function (route) {
      return this.getURL() + route
    },
    Authorization : 'Basic YWRtaW46YWRtaW4'
  },
  Distant: {
    host : SYNCHRO_WS_URL,  // 'http://dev.aa.www.spid-escaleo.net3-courrier.extra.laposte.fr' en dev
    port : SYNCHRO_WS_PORT, // 81 en dev
    baseRoute : '/synchro',
    env : SYNCHRO_WS_ENV,
    getURL : function () {
        //console.log('SYNCHRO URL ENV = ' + this.env)
        if(this.env == 'prod' || this.env == 'pprd') {
            return this.host + this.baseRoute
       }
        else {
            return this.host + ':' + this.port + this.baseRoute
        }
    },
    getURLFor : function (route) {
      return this.getURL() + route
    },
    Authorization : 'Basic dXNlcm5hbWUxOnBhc3N3b3JkMQ=='
  }
})
